import React from 'react';

const DataInvestorMarket = () => {
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Data Investor Market</h1>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Market Data & Investor Relations</h5>
              <p className="card-text">
                Track market performance and manage investor relations data.
              </p>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h6>Market Performance</h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <span>Stock Price:</span>
                        <span className="text-success">$125.67 <i className="bi bi-arrow-up"></i></span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Market Cap:</span>
                        <span>$2.4B</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>P/E Ratio:</span>
                        <span>18.5</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h6>Investor Relations</h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <span>Active Investors:</span>
                        <span>1,247</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Institutional Holdings:</span>
                        <span>67.3%</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Next Earnings:</span>
                        <span>Q3 2025</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataInvestorMarket;